/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Location} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnInit, Optional} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NbWindowRef} from '@nebular/theme';
import {DamExternalUpload, FileService} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../admin-shared/crud-components/create-update/create-update.component';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {FormConfigService} from '../../../admin-shared/services/form-config.service';
import {DamService} from '../dam.service';
import {DAM_EXTERNAL_UPLOAD_FORM} from './dam-external-upload-forms.config';

@Component({
  selector: 'app-dam-external-upload',
  templateUrl: './dam-external-upload.component.html',
  styleUrls: ['./dam-external-upload.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamExternalUploadComponent extends CreateUpdateComponent<DamExternalUpload> implements OnInit {

  constructor(protected readonly formConfigService: FormConfigService,
              protected readonly route: ActivatedRoute,
              protected readonly location: Location,
              @Optional() protected readonly windowRef: NbWindowRef,
              protected readonly fileService: FileService,
              protected readonly damService: DamService
  ) {
    super(formConfigService, route, location, windowRef, fileService);
  }

  uploadUrl = '';
  title = 'Поделиться';
  protected uri = '/dam-external-upload';
  absolutePath = '/cabinet/dam-external-upload';
  model: any;
  isModal = true;
  protected entity: any;
  config: CrudConfig = {
    uri: this.uri,
    columns: DAM_EXTERNAL_UPLOAD_FORM,
    title: this.title,
    absolutePath: this.absolutePath,
  };

  @Input()
  damCatalog: number;

  ngOnInit(): void {
    super.setConfig(this.config);
    super.ngOnInit();
    this.model.startDate = null;
    this.model.endDate = null;
    console.log(1);
    console.log(this.damCatalog);
    this.redirectToEditPage = true;
    this.cdr.detectChanges();
  }

  beforeSubmit(): void {
    this.entity = {};
    this.entity.id = this.model.id;
    this.entity.header = this.model.header;
    this.entity.damCatalogId = this.damCatalog;
    this.entity.startDate = this.model.startDate === null ? null : this.convertDate(this.model.startDate);
    this.entity.endDate = this.model.endDate === null ? null : this.convertDate(this.model.endDate);
    this.entity.enabled = this.model.enabled;
    console.log(this.entity);
  }

  afterSubmit(): void {
    this.uploadUrl = this.createdId;
    this.cdr.detectChanges();
  }

  private convertDate(date: Date): string {
    const ye = new Intl.DateTimeFormat('ru', {year: 'numeric'}).format(date);
    const mo = new Intl.DateTimeFormat('ru', {month: '2-digit'}).format(date);
    const da = new Intl.DateTimeFormat('ru', {day: '2-digit'}).format(date);

    return ye + '-' + mo + '-' + da;
  }

  copyShareUrl(shareUrl) {
    navigator.clipboard.writeText(shareUrl).then(item => {
      this.successToast(translations.copiedToClipboard);
    });
  }
}
